import React from 'react';
import PropTypes from 'prop-types';

import FolderWrapperWrapper from '../../../../sharedComponents/FolderWrapperWrapper';
import HeartWrapper from 'dibs-portfolio-heart';
import { getFolderTrackingHooks, locations } from '../../../../utils/folderTracking';
import { trackEvent } from 'dibs-tracking';

import styles from './styles/FavoriteIcons.scss';

function trackFavoriting(action, itemPk) {
    let trackObj = {
        action,
        label: 'discovery',
        category: 'item favoriting',
    };

    if (itemPk) {
        trackObj = { ...trackObj, additional: { itemPk } };
    }

    trackEvent(trackObj);
}

export function FavoriteIcons({
    itemId,
    userId,
    imageUrl,
    title,
    viewer,
    disable,
    shouldFillInFolder,
    loadPortfolioData,
    selectedItemIds,
}) {
    if (!itemId) {
        return null;
    }
    return (
        <React.Fragment>
            <div className={styles.heart}>
                <HeartWrapper
                    authModalShow={() => {}}
                    itemId={itemId}
                    loadPortfolioData={loadPortfolioData}
                    onFavorited={() => trackFavoriting('item added', itemId)}
                    onUnFavorited={() => trackFavoriting('item removed', itemId)}
                    selectedItemIds={selectedItemIds}
                    userId={userId ? userId : null}
                    userIds={userId ? [userId] : []}
                    viewer={viewer || null}
                />
            </div>
            <div className={styles.folder}>
                <FolderWrapperWrapper
                    additionalIconClass={styles.folderIcon}
                    authModalTrackingLabel="save item - discover feed"
                    disable={disable}
                    primaryItemPk={itemId}
                    selectedItemIds={selectedItemIds}
                    selectedItemImages={imageUrl ? [imageUrl] : []}
                    selectedItemTitles={title ? [title] : []}
                    shouldFillInFolder={shouldFillInFolder}
                    singlePortfolioItem
                    trackingHooks={getFolderTrackingHooks(locations.DISCOVER_FEED)}
                    userId={userId || null}
                    userIds={userId ? [userId] : null}
                    viewer={viewer || null}
                />
            </div>
        </React.Fragment>
    );
}

FavoriteIcons.propTypes = {
    itemId: PropTypes.string,
    imageUrl: PropTypes.string,
    title: PropTypes.string,
    userId: PropTypes.string,
    viewer: PropTypes.object,
    disable: PropTypes.bool,
    shouldFillInFolder: PropTypes.bool,
    loadPortfolioData: PropTypes.bool,
    selectedItemIds: PropTypes.array,
};
